import { render, staticRenderFns } from "./EditDetryStockComponent.vue?vue&type=template&id=0c072ffc"
import script from "./EditDetryStockComponent.vue?vue&type=script&lang=js"
export * from "./EditDetryStockComponent.vue?vue&type=script&lang=js"
import style0 from "./EditDetryStockComponent.vue?vue&type=style&index=0&id=0c072ffc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports